import {Table, Typography} from "antd";
import {CaruzEnrollment} from "../../models/CaruzEnrollment";
import {useEffect, useState} from "react";
import './Participants.css';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {CHANGE_COMP} from "../../store";
import {FOUR_SPORT_LIVE_URL} from "../../constants";
import {DisplayState} from "../../reducers/displayReducer";
import {ColumnDefinitions} from "../../constants/display-columns";
import {getCurrentTimeMills, MILLS_IN_MINUTE, timeToMills} from "../../utils";

const {Text} = Typography

interface IEnrollmentsResponse {
    caruzEnrollments: CaruzEnrollment[]
}

interface IState {
    displayReducer: DisplayState
}

export function Participants() {
    const dispatch = useDispatch()
    const { comp: compQueryParam } = useParams() as { comp?: string };
    const comp = compQueryParam ? +compQueryParam : null;
    const [caruzEnrollments, setCaruzEnrollments] = useState<CaruzEnrollment[]>([])
    const selectedColumns = useSelector((state: IState) => state.displayReducer.SelectedColumns);
    const contentFontSize = useSelector((state: IState) => state.displayReducer.ContentFontSize);
    const headerFontSize = useSelector((state: IState) => state.displayReducer.HeaderFontSize);
    const selectedLocations = useSelector((state: IState) => state.displayReducer.SelectedLocations);
    const [render, setRender] = useState(1)
    const navigate = useNavigate()
    const includeUnrecognizedChips = useSelector((state: IState) => state.displayReducer.IncludeUnrecognizedChips);

    useEffect(()=> {
        if(!comp) {
            navigate('/events')
            return
        }
        let timer: NodeJS.Timeout
        fetch(`${FOUR_SPORT_LIVE_URL}/caruz/getCaruzEnrollment/`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Token ' + localStorage.getItem('caruzToken')
            },
            body: JSON.stringify({
                locations: selectedLocations,
                includeUnrecognizedChips,
                comp
            })
        }).then(response => response.json()).then((response: IEnrollmentsResponse) => {
            setCaruzEnrollments(CaruzEnrollment.instantiateFromArr(response.caruzEnrollments))
            timer = setTimeout(() => setRender((render) => render + 1) , 500)
        }).catch((error: any) => {
            console.log(error)
            timer = setTimeout(() => setRender((render) => render + 1) , 500)
        })
        return () => clearTimeout(timer);
    }, [render, navigate, selectedLocations, comp, includeUnrecognizedChips])

    useEffect(() => {
        dispatch({
            type: CHANGE_COMP,
            payload: { comp }
        });
    }, [comp, dispatch]);


    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        params.set("contentFontSize", contentFontSize.toString());
        params.set("headerFontSize", headerFontSize.toString());

        params.delete("selectedColumns");
        selectedColumns.forEach(column => params.append("selectedColumns", column));

        params.delete("selectedLocations");
        selectedLocations.forEach(location => params.append("selectedLocations", location));

        const queryParams = params.toString();
        const newUrl = queryParams ? `${window.location.pathname}?${queryParams}` : window.location.pathname;
        window.history.replaceState({}, "", newUrl);
    }, [selectedLocations, headerFontSize, contentFontSize, selectedColumns]);

    useEffect(() => {
        localStorage.setItem("caruz_contentFontSize", contentFontSize.toString());
        localStorage.setItem("caruz_headerFontSize", headerFontSize.toString());
        localStorage.setItem("caruz_selectedColumns", JSON.stringify(selectedColumns));
    }, [contentFontSize, headerFontSize, selectedColumns]);

    const getColumnsForUi = () => {
        const selectedColumnsSet = new Set(selectedColumns)
        return ColumnDefinitions.filter(column => selectedColumnsSet.has(column.key)).map(columnDefinition => {
            return {
                title: <Text style={{fontSize: `${headerFontSize}px`}}>{columnDefinition.description}</Text>,
                text: columnDefinition.description,
                dataIndex: columnDefinition.key,
                key: columnDefinition.key,
                width: columnDefinition.width,
                align: columnDefinition.textAlign,
                visible: true,
                render: (_: string, caruzEnrollment: CaruzEnrollment) => {
                    return <Text style={{fontSize: `${contentFontSize}px`}}>{caruzEnrollment.getValueForColumnKey(columnDefinition.key)}</Text>
                }
            }
        })
    }

    return (
        <Table
            dataSource={caruzEnrollments}
            columns={getColumnsForUi()}
            pagination={false}
            rowClassName={(record, index) => {
                const oddEvenClass = index % 2 === 0 ? 'odd-row' : '';

                // not the latest record
                if(index > 0) {
                    return oddEvenClass
                }

                // unrecognized record
                if(!record.number) {
                    return oddEvenClass
                }

                try {
                    const millsSinceRecordTime = getCurrentTimeMills() - timeToMills(record.time)
                    // not from the last minute
                    if(millsSinceRecordTime > MILLS_IN_MINUTE) {
                        return oddEvenClass
                    }

                    return `latest-row ${oddEvenClass}`;
                }
                catch (e) {
                    return oddEvenClass
                }
            }}
        />
    )
}